import * as i0 from '@angular/core';
import * as i1 from './timepicker.module';
import * as i2 from '@angular/common';
import * as i3 from './timepicker.component';
export const TimepickerModuleNgFactory:i0.NgModuleFactory<i1.TimepickerModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.TimepickerComponent = (<any>(null as any));
var _decl0_12:i2.AsyncPipe = (<any>(null as any));
var _decl0_13:i2.UpperCasePipe = (<any>(null as any));
var _decl0_14:i2.LowerCasePipe = (<any>(null as any));
var _decl0_15:i2.JsonPipe = (<any>(null as any));
var _decl0_16:i2.SlicePipe = (<any>(null as any));
var _decl0_17:i2.DecimalPipe = (<any>(null as any));
var _decl0_18:i2.PercentPipe = (<any>(null as any));
var _decl0_19:i2.TitleCasePipe = (<any>(null as any));
var _decl0_20:i2.CurrencyPipe = (<any>(null as any));
var _decl0_21:i2.DatePipe = (<any>(null as any));
var _decl0_22:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_23:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_24:i2.CommonModule = (<any>(null as any));
var _decl0_25:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_26:i0.ElementRef<any> = (<any>(null as any));
function _View_TimepickerComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_TimepickerComponent_1_1():void {
  if (_decl0_11.showMinutes) { var _any:any = (null as any); }
}
function _View_TimepickerComponent_1_2():void {
  if (_decl0_11.showMinutes) {
    var _any:any = (null as any);
    const currVal_0:any = (!_decl0_11.canIncrementMinutes || !_decl0_11.isEditable);
    currVal_0;
    const pd_1:any = ((<any>_decl0_11.changeMinutes(_decl0_11.minuteStep)) !== false);
  }
}
function _View_TimepickerComponent_1_3():void {
  if (_decl0_11.showSeconds) { var _any:any = (null as any); }
}
function _View_TimepickerComponent_1_4():void {
  if (_decl0_11.showSeconds) {
    var _any:any = (null as any);
    const currVal_0:any = (!_decl0_11.canIncrementSeconds || !_decl0_11.isEditable);
    currVal_0;
    const pd_1:any = ((<any>_decl0_11.changeSeconds(_decl0_11.secondsStep)) !== false);
  }
}
function _View_TimepickerComponent_1_5():void {
  if (_decl0_11.showMeridian) { var _any:any = (null as any); }
}
function _View_TimepickerComponent_1_6():void {
  if (_decl0_11.showMeridian) { var _any:any = (null as any); }
}
function _View_TimepickerComponent_1_7():void {
  if (_decl0_11.showMinutes) { var _any:any = (null as any); }
}
function _View_TimepickerComponent_1_8():void {
  if (_decl0_11.showMinutes) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_11.invalidMinutes;
    currVal_0;
    const currVal_1:any = _decl0_11.invalidMinutes;
    currVal_1;
    const currVal_2:any = _decl0_11.readonlyInput;
    currVal_2;
    const currVal_3:any = _decl0_11.disabled;
    currVal_3;
    const currVal_4:any = _decl0_11.minutes;
    currVal_4;
    _decl0_11.prevDef(_any);
    const pd_5:any = ((<any>_decl0_11.changeMinutes((_decl0_11.minuteStep * _decl0_11.wheelSign(_any)),
        'wheel')) !== false);
    const pd_6:any = ((<any>_decl0_11.changeMinutes(_decl0_11.minuteStep,'key')) !== false);
    const pd_7:any = ((<any>_decl0_11.changeMinutes((0 - _decl0_11.minuteStep),'key')) !== false);
    const pd_8:any = ((<any>_decl0_11.updateMinutes(_any.target.value)) !== false);
  }
}
function _View_TimepickerComponent_1_9():void {
  if (_decl0_11.showSeconds) { var _any:any = (null as any); }
}
function _View_TimepickerComponent_1_10():void {
  if (_decl0_11.showSeconds) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_11.invalidSeconds;
    currVal_0;
    const currVal_1:any = _decl0_11.invalidSeconds;
    currVal_1;
    const currVal_2:any = _decl0_11.readonlyInput;
    currVal_2;
    const currVal_3:any = _decl0_11.disabled;
    currVal_3;
    const currVal_4:any = _decl0_11.seconds;
    currVal_4;
    _decl0_11.prevDef(_any);
    const pd_5:any = ((<any>_decl0_11.changeSeconds((_decl0_11.secondsStep * _decl0_11.wheelSign(_any)),
        'wheel')) !== false);
    const pd_6:any = ((<any>_decl0_11.changeSeconds(_decl0_11.secondsStep,'key')) !== false);
    const pd_7:any = ((<any>_decl0_11.changeSeconds((0 - _decl0_11.secondsStep),'key')) !== false);
    const pd_8:any = ((<any>_decl0_11.updateSeconds(_any.target.value)) !== false);
  }
}
function _View_TimepickerComponent_1_11():void {
  if (_decl0_11.showMeridian) { var _any:any = (null as any); }
}
function _View_TimepickerComponent_1_12():void {
  if (_decl0_11.showMeridian) {
    var _any:any = (null as any);
    const currVal_0:any = (!_decl0_11.isEditable || !_decl0_11.canToggleMeridian);
    currVal_0;
    const currVal_1:any = (!_decl0_11.isEditable || !_decl0_11.canToggleMeridian);
    currVal_1;
    const currVal_2:any = _decl0_11.meridian;
    currVal_2;
    const pd_3:any = ((<any>_decl0_11.toggleMeridian()) !== false);
  }
}
function _View_TimepickerComponent_1_13():void {
  if (_decl0_11.showMinutes) { var _any:any = (null as any); }
}
function _View_TimepickerComponent_1_14():void {
  if (_decl0_11.showMinutes) {
    var _any:any = (null as any);
    const currVal_0:any = (!_decl0_11.canDecrementMinutes || !_decl0_11.isEditable);
    currVal_0;
    const pd_1:any = ((<any>_decl0_11.changeMinutes((0 - _decl0_11.minuteStep))) !== false);
  }
}
function _View_TimepickerComponent_1_15():void {
  if (_decl0_11.showSeconds) { var _any:any = (null as any); }
}
function _View_TimepickerComponent_1_16():void {
  if (_decl0_11.showSeconds) {
    var _any:any = (null as any);
    const currVal_0:any = (!_decl0_11.canDecrementSeconds || !_decl0_11.isEditable);
    currVal_0;
    const pd_1:any = ((<any>_decl0_11.changeSeconds((0 - _decl0_11.secondsStep))) !== false);
  }
}
function _View_TimepickerComponent_1_17():void {
  if (_decl0_11.showMeridian) { var _any:any = (null as any); }
}
function _View_TimepickerComponent_1_18():void {
  if (_decl0_11.showMeridian) { var _any:any = (null as any); }
}
function _View_TimepickerComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = !_decl0_11.showSpinners;
  currVal_0;
  const currVal_1:any = (!_decl0_11.canIncrementHours || !_decl0_11.isEditable);
  currVal_1;
  const currVal_2:any = _decl0_11.showMinutes;
  currVal_2;
  const currVal_3:any = _decl0_11.showMinutes;
  currVal_3;
  const currVal_4:any = _decl0_11.showSeconds;
  currVal_4;
  const currVal_5:any = _decl0_11.showSeconds;
  currVal_5;
  const currVal_6:any = _decl0_11.showMeridian;
  currVal_6;
  const currVal_7:any = _decl0_11.showMeridian;
  currVal_7;
  const currVal_8:any = _decl0_11.invalidHours;
  currVal_8;
  const currVal_9:any = _decl0_11.invalidHours;
  currVal_9;
  const currVal_10:any = _decl0_11.readonlyInput;
  currVal_10;
  const currVal_11:any = _decl0_11.disabled;
  currVal_11;
  const currVal_12:any = _decl0_11.hours;
  currVal_12;
  const currVal_13:any = _decl0_11.showMinutes;
  currVal_13;
  const currVal_14:any = _decl0_11.showMinutes;
  currVal_14;
  const currVal_15:any = _decl0_11.showSeconds;
  currVal_15;
  const currVal_16:any = _decl0_11.showSeconds;
  currVal_16;
  const currVal_17:any = _decl0_11.showMeridian;
  currVal_17;
  const currVal_18:any = _decl0_11.showMeridian;
  currVal_18;
  const currVal_19:any = !_decl0_11.showSpinners;
  currVal_19;
  const currVal_20:any = (!_decl0_11.canDecrementHours || !_decl0_11.isEditable);
  currVal_20;
  const currVal_21:any = _decl0_11.showMinutes;
  currVal_21;
  const currVal_22:any = _decl0_11.showMinutes;
  currVal_22;
  const currVal_23:any = _decl0_11.showSeconds;
  currVal_23;
  const currVal_24:any = _decl0_11.showSeconds;
  currVal_24;
  const currVal_25:any = _decl0_11.showMeridian;
  currVal_25;
  const currVal_26:any = _decl0_11.showMeridian;
  currVal_26;
  const pd_27:any = ((<any>_decl0_11.changeHours(_decl0_11.hourStep)) !== false);
  _decl0_11.prevDef(_any);
  const pd_28:any = ((<any>_decl0_11.changeHours((_decl0_11.hourStep * _decl0_11.wheelSign(_any)),
      'wheel')) !== false);
  const pd_29:any = ((<any>_decl0_11.changeHours(_decl0_11.hourStep,'key')) !== false);
  const pd_30:any = ((<any>_decl0_11.changeHours((0 - _decl0_11.hourStep),'key')) !== false);
  const pd_31:any = ((<any>_decl0_11.updateHours(_any.target.value)) !== false);
  const pd_32:any = ((<any>_decl0_11.changeHours((0 - _decl0_11.hourStep))) !== false);
}
